(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initSocialProof() {
    var socialProofBlocks = document.querySelectorAll('[data-social-proof][data-randomized="true"]');
    if (!socialProofBlocks.length) return;

    socialProofBlocks.forEach(function (block) {
      var productId = block.getAttribute('data-product-id');
      var count = parseInt(block.getAttribute('data-visible-count'), 10) || 3;
      var tailTemplate = block.querySelector('template[data-social-proof-tail-source]');
      var verifiedTemplate = block.querySelector('template[data-social-proof-verified-source]');
      var tailHtml = tailTemplate ? tailTemplate.innerHTML : '';
      var verifiedHtml = verifiedTemplate ? verifiedTemplate.innerHTML : '';
      var cacheKey = 'social-proof-' + productId;
      var avatarsContainer = block.querySelector('[data-social-proof-avatars]');
      var textContainer = block.querySelector('[data-social-proof-text]');
      if (!avatarsContainer) return;

      var items = Array.prototype.slice
        .call(block.querySelectorAll('[data-review-item]'))
        .map(function (item) {
          return {
            name: item.getAttribute('data-name'),
            image: item.getAttribute('data-image')
          };
        })
        .filter(function (item) {
          return item.name && item.image;
        });

      if (!items.length) return;

      var selected = [];
      var cached = sessionStorage.getItem(cacheKey);

      if (cached) {
        try {
          var cachedIndexes = JSON.parse(cached);
          selected = cachedIndexes
            .map(function (index) {
              return items[index];
            })
            .filter(Boolean);
        } catch (e) {
          selected = [];
        }
      }

      if (!selected.length) {
        var availableIndexes = items.map(function (_, index) {
          return index;
        });
        var selectedIndexes = [];
        var total = Math.min(count, items.length);

        while (selectedIndexes.length < total) {
          var randomIndex = Math.floor(Math.random() * availableIndexes.length);
          selectedIndexes.push(availableIndexes.splice(randomIndex, 1)[0]);
        }

        sessionStorage.setItem(cacheKey, JSON.stringify(selectedIndexes));
        selected = selectedIndexes.map(function (index) {
          return items[index];
        });
      }

      avatarsContainer.innerHTML = selected
        .map(function (item) {
          return (
            '<span class="product-social-proof__avatar" title="' +
            escapeHtml(item.name) +
            '"><img loading="lazy" src="' +
            item.image +
            '" alt="' +
            escapeHtml(item.name) +
            '" width="40" height="40"></span>'
          );
        })
        .join('');

      if (textContainer) {
        var leadingNames = selected.slice(0, 2).map(function (item) {
          return (
            '<span class="product-social-proof__name-group">' +
            '<strong>' +
            escapeHtml(item.name) +
            '</strong>' +
            '<span class="product-social-proof__verified" aria-hidden="true">' +
            verifiedHtml +
            '</span>' +
            '</span>'
          );
        });

        var namesHtml = '';
        if (leadingNames.length > 1) {
          namesHtml = leadingNames[0] + ', ' + leadingNames[1] + ' ';
        } else if (leadingNames.length === 1) {
          namesHtml = leadingNames[0] + ' ';
        }

        textContainer.innerHTML =
          namesHtml + '<div class="product-social-proof__tail rte">' + tailHtml + '</div>';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialProof);
  } else {
    initSocialProof();
  }
})();
